<template>
    <base-card-list>
        <!-- TODO: Round corners of first/last element with background at top or bottom respectively -->
        <service-incident-card-list-entry v-for="(incident, index) in incidents" :key="incident.id" :interruption="incident" :class="{'bg-gray-100' : index % 2 !== 0}">
        </service-incident-card-list-entry>
    </base-card-list>
</template>

<script>
    export default {
        props: {
            incidents: {
                required: true,
                type: Array,
            },
        },
    }
</script>
